export interface Option<T> {
  name: string
  element: T
}

type Props = {
  name: string
  onClick: () => void
}

export const SuggestsOption = ({ name, onClick }: Props) => (
  <div key={name} className="suggests-option" onClick={onClick}>
    <div className="suggests-option__title">
      <span style={{ paddingLeft: '6px' }}>{name}</span>
    </div>
  </div>
)
